import axios, { AxiosInstance } from 'axios';

export const createGoogleClient = (baseUrl?: string): AxiosInstance => {
  const client = axios.create({
    baseURL: baseUrl ? `${baseUrl}/google` : '',
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const errorMessage = error.response.data?.error || error.message;
        console.error('Place API error:', errorMessage);
      } else if (error.request) {
        console.error('Place API network error:', error.message);
      }
      return Promise.reject(error);
    },
  );

  return client;
};

export default createGoogleClient;
